export interface NotificationsResBody {
  notificationId: string;
  patientId?: string;
  practitionerId?: string;
  practitioner?: any;
  patient?: any;
  type: NotificationType;
  content: any;
  createdOn: string;
  isRead?: boolean,
}

export interface NotificationsReqParams {
  pageNumber?: number;
  pageSize?: number;
  patientId?: string;
}

export interface NotificationsListResBody {
  data: NotificationsResBody[];
  pageNumber: number;
  pageSize: number;
  totalCount: number;
  totalPages: number;
  totalUnread?: number;
}

export interface MarkNotificationReadByServiceRequestReqBody {
  serviceRequestId: string;
  subject?: string;
}

export type MarkNotificationReadByServiceRequestResBody = NotificationsResBody[];

export interface MarkNotificationReadReqBody {
  notificationId: string;
  subject?: string;
}

export type MarkNotificationReadResBody = NotificationsResBody;

export enum NotificationType {
  CONSULTATION_REQUEST = 'consultationRequest',
  CONSULTATION_CANCELLED = 'consultationCancelled',
  CONSULTATION_ACCEPTED = 'consultationAccepted',
  CONSULTATION_DECLINED = 'consultationDeclined',
  CONSULTATION_PAID = 'consultationPaid',
  CONSULTATION_COMPLETED = 'consultationCompleted',
  CONSULTATION_ARCHIVED = 'consultationArchived',
  PRACTITIONER_PROFILE_PENDING = 'pendingPractitionerProfile',
  PRACTITIONER_PROFILE_DECLINED = 'practitionerProfileDeclined',
  PRACTITIONER_PROFILE_VERIFIED = 'practitionerProfileVerified',
  ATTACHED_DIAGNOSTIC_REPORT = 'diagnosticReportAttached',
  ATTACHED_MEDICATION_REQUEST = 'medicationRequestAttached',
  ATTACHED_LABORATORY_REQUEST = 'laboratoryRequestAttached',
  MESSAGE_ADDED = 'messageAdded',
  SCHEDULED_CALL_REQUEST = 'scheduledCallRequest',
  APPOINTMENT_REQUEST = 14,
}
